import { PureComponent } from 'react'

interface ISettingsProps {
	onSettingsSubmit: (settings: any) => void
}

class SplashNoSettings extends PureComponent<ISettingsProps> {
	render() {
		return null
	}
}

export default SplashNoSettings
